import * as moment from 'moment-timezone';
import * as _ from 'underscore';
import { Formatters } from '../../codegen/Localize';
import { Module } from '../Module';
import { ServerService } from './ServerService';
import { ToasterService, ToastType } from './ToasterService';

export interface FutureAction {
  messageKey: string;
  targetDate: Date;
  showNewMessage: (newMessage: string) => void;
  refreshRateMillis?: number;
  minumumTimeDiffMillis?: number; // We will ignore messages where the remaining time is less than this value.
  dateArrivedListener?: () => void;
}

export class NotifyingFutureActionService {

  private static DEFAULT_REFRESH_RATE = 1000; // 1 second
  // We will ignore messages where the remaining time is less than this value.
  private static MINIMUM_TIME_DIFF = 1000; // 1 second

  public static $inject = [
    '$timeout',
    '$translate',
  ];

  constructor(
    private $timeout: ng.ITimeoutService,
    private $translate: ng.translate.ITranslateService,
    ) {}

  public register(action: FutureAction): void {
      this.setupNewToast(action);
  }

  private setupNewToast = (action: FutureAction): void => {
    const now = moment();
    const targetDate = moment(action.targetDate);
    const minimumTimeDiffMillis = action.minumumTimeDiffMillis == null ?
        NotifyingFutureActionService.MINIMUM_TIME_DIFF : action.minumumTimeDiffMillis;
    const timeDiff = moment.duration(targetDate.diff(now));
    // If the date is in the future, and more than the minimum time we ignore.
    if (timeDiff.asMilliseconds() > minimumTimeDiffMillis) {
      const refreshRate = action.refreshRateMillis == null ?
        NotifyingFutureActionService.DEFAULT_REFRESH_RATE : action.refreshRateMillis;

      // Show the message
      const message = this.$translate.instant(action.messageKey) +
        Formatters.formatLongBestFitRelativeTime(action.targetDate);
      action.showNewMessage(message);

      // Register the recursive call to set the updated message.
      this.$timeout(() => this.setupNewToast(action), refreshRate);
    } else {
        // Target moment has arrived.
        if (action.dateArrivedListener != null) {
            action.dateArrivedListener();
        }
    }
  }
}

Module.instance().service('NotifyingFutureActionService', NotifyingFutureActionService);
